import React from "react";
import { Link } from "react-router-dom";
import Icon from "../components/ui/Icon";
import TypesOfCaregiversDetail from "../components/ModelDetails/TypesOfCaregiversDetail";

const TypesOfCaregivers = () => {
  return (
    <div className="container mx-auto px-3 lg:px-5">
      <div className="fixed left-4 top-4 z-[200]">
        <Link to="/">
          <Icon src="/assets/svgs/home_button.svg" alt="Back to home" />
        </Link>
      </div>

      <TypesOfCaregiversDetail />
    </div>
  );
};

export default TypesOfCaregivers;
